var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-with-side clearfix",style:(_vm.containerStyle)},[_c('aside',{staticClass:"mb-3 mb-xl-0",style:(_vm.sidebarStyle)},[_vm._t("sidebar")],2),_c('div',[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }